"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROOM_TYPE = exports.ROOM_COUNT = void 0;
// Define the values for room count
var ROOM_COUNT;
(function (ROOM_COUNT) {
    ROOM_COUNT["ONE"] = "gte_1-lt_2";
    ROOM_COUNT["TWO"] = "gte_2-lt_3";
    ROOM_COUNT["TREE"] = "gte_3-lt_4";
    ROOM_COUNT["FOUR"] = "gte_4";
})(ROOM_COUNT = exports.ROOM_COUNT || (exports.ROOM_COUNT = {}));
var ROOM_TYPE;
(function (ROOM_TYPE) {
    ROOM_TYPE["FIELD_NAME"] = "rooms";
})(ROOM_TYPE = exports.ROOM_TYPE || (exports.ROOM_TYPE = {}));
